import Vue from 'vue';

class HelpersDefinition extends Vue 
{
    DispatchWindowEvent(eventName) {
        let event;
        if (typeof(Event) === 'function') {
            event = new Event(eventName);
        } else {
            event = document.createEvent('Event');
            event.initEvent(eventName, true, true);
        }        
        window.dispatchEvent(event);
    }

    GetLocationWithoutQuery() {
        return window.location.protocol + '//' + window.location.host + window.location.pathname;
    }

    GetQueryParameter(name: string): string | null {
        const uri = window.location.href.split('?');
        if (uri.length === 2) {
          const vars = uri[1].split('&');
          for (let i = 0; i < vars.length; i++) {
            const parameterInfo = vars[i].split('=');
            if (parameterInfo.length === 2 &&
                parameterInfo[0].toLowerCase() === name.toLowerCase()) {
                return parameterInfo[1].toString();
            }
          }
        }
        return null;
    }
}

export const Helpers = new HelpersDefinition();